{
  "iframe": "Add a frame",
  "image": "Add an image",
  "link": "Add a link",
  "file": "Add a file"
}
